// extracted by mini-css-extract-plugin
export default {"loader-container":"Loader_loader-container__M9c0L","loader":"Loader_loader__QfeB1","spin89345":"Loader_spin89345__tsH0Q"};